import { http } from "../../utils/config";

const receiptAPI = {
  getReceipt: (code) => {
    return http.get(`/api/v1/receipts/${code}`);
  },
  
  getCampain: (code) => {
    return http.get(`/api/v1/campain-customers/${code}`);
  },
  generateQrcode: (code, data) => http.post(`/api/v1/campain-customers/${code}`, data),

  // Xuất hàng loạt chỉ ghi nhận yêu cầu, file dựng ở hàng đợi. Không còn responseType blob:
  // một khu phố 400 phiếu mất ~40 giây, xuất toàn bộ tới hàng chục phút, mà axios cắt ở 20s.
  exportAllParentReceiptPdf: (id) => {
    return http.post(`/api/v1/receipts/export/parent/${id}/all`);
  },
  exportAllReceiptPdf: (id) => {
    return http.post(`/api/v1/receipts/export/${id}/all`);
  },

  // Một phiếu vẫn tải trực tiếp.
  exportReceiptPdf: (id) => {
    return http.get(`/api/v1/receipts/export/${id}/one`, {
      responseType: "blob",
    });
  },

  // Lịch sử lấy theo đợt thu cha nên gồm cả lượt xuất toàn bộ lẫn từng đơn vị.
  getExportHistories: (rootId) => {
    return http.get(`/api/v1/receipts/export/histories/${rootId}`);
  },
  downloadExport: (id) => {
    return http.get(`/api/v1/receipts/export/download/${id}`, {
      responseType: "blob",
      // File zip của một lượt xuất toàn bộ có thể vài chục MB, tải lâu hơn 20s mặc định.
      timeout: 180000,
    });
  },

  // Cấu hình phiếu thu của chủ đợt thu đang đăng nhập.
  getSettings: () => http.get(`/api/v1/receipts/settings`),
  updateSettings: (data) => http.put(`/api/v1/receipts/settings`, data),
  resetSettings: () => http.delete(`/api/v1/receipts/settings`),
  // Xem thử dựng từ dữ liệu đang sửa, chưa lưu.
  previewSettings: (data) =>
    http.post(`/api/v1/receipts/settings/preview`, data, { responseType: "blob" }),
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response.data;
    } catch (error) {
      console.error("API Error:", error);

      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const { status, data } = error.response;
        let parsed = {};

        // Nếu backend trả về Blob (khi responseType: 'blob')
        if (data instanceof Blob) {
          try {
            const text = await data.text();
            parsed = JSON.parse(text);
          } catch (e) {
            console.error("Failed to parse Blob error:", e);
          }
        }

        // Lấy message ưu tiên: parsed.message > data.message
        const msg = parsed.message || data?.message;

        switch (status) {
          case 400:
            throw new Error(msg || "Dữ liệu không hợp lệ");
          case 401:
            throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
          case 403:
            throw new Error("Bạn không có quyền thực hiện thao tác này");
          case 404:
            throw new Error("Không tìm thấy thông tin");
          case 422:
            throw new Error(msg || "Dữ liệu không hợp lệ");
          case 500:
            throw new Error(msg || "Lỗi server, vui lòng thử lại sau");
          default:
            throw new Error(msg || "Đã có lỗi xảy ra");
        }
      } else if (error.request) {
        // Network error
        throw new Error("Không thể kết nối đến server");
      } else {
        // Other error
        throw new Error(error.message || "Đã có lỗi xảy ra");
      }
    }
  };
};

// Wrapped API functions with error handling
export const receiptAPIWithErrorHandling = {
  exportAllReceiptPdf: withErrorHandling(receiptAPI.exportAllReceiptPdf),
  exportAllParentReceiptPdf: withErrorHandling(receiptAPI.exportAllParentReceiptPdf),
  exportReceiptPdf: withErrorHandling(receiptAPI.exportReceiptPdf),
  getExportHistories: withErrorHandling(receiptAPI.getExportHistories),
  downloadExport: withErrorHandling(receiptAPI.downloadExport),
  getReceipt: withErrorHandling(receiptAPI.getReceipt),
  getCampain: withErrorHandling(receiptAPI.getCampain),
  generateQrcode: withErrorHandling(receiptAPI.generateQrcode),
  getSettings: withErrorHandling(receiptAPI.getSettings),
  updateSettings: withErrorHandling(receiptAPI.updateSettings),
  resetSettings: withErrorHandling(receiptAPI.resetSettings),
  previewSettings: withErrorHandling(receiptAPI.previewSettings),
};

export default receiptAPI;
